import { render, staticRenderFns } from "./TestingSuiteStandalone.vue?vue&type=template&id=a21be220"
import script from "./TestingSuiteStandalone.vue?vue&type=script&lang=js"
export * from "./TestingSuiteStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports